import { Controller } from "@hotwired/stimulus"
import { visitIndexWithOptions } from "../utils/index_options_visit"

// Sur-header des filtres actifs (turbo_index) — suppression unitaire ou totale.
export default class extends Controller {
  static values = {
    options: { type: Object, default: {} },
    path: String,
    searchResultsFrameId: String,
  }

  remove(event) {
    event.preventDefault()
    event.stopPropagation()

    const key = event.params.key
    if (!key) return

    const options = structuredClone(this.optionsValue || {})
    const f = { ...(options.f || {}) }

    if (key === "query") {
      delete options.query
    } else if (key === "sort") {
      delete options.sort_by
      delete options.sort_reverse
    } else if (key.startsWith("f:")) {
      const attr = key.slice(2)
      delete f[attr]
      if (String(options.sort_by) === attr) {
        delete options.sort_by
        delete options.sort_reverse
      }
    }

    if (Object.keys(f).length === 0) {
      delete options.f
    } else {
      options.f = f
    }

    delete options.page

    this.visit(options, { clearQuery: key === "query" })
  }

  clearAll(event) {
    event.preventDefault()
    event.stopPropagation()

    const options = structuredClone(this.optionsValue || {})
    delete options.f
    delete options.query
    delete options.sort_by
    delete options.sort_reverse
    delete options.page

    this.visit(options, { clearQuery: true })
  }

  visit(options, { clearQuery = false } = {}) {
    visitIndexWithOptions({
      path: this.pathValue,
      options,
      clearQuery,
      element: this.element,
      searchResultsFrameId: this.searchResultsFrameIdValue,
    })
  }
}
